import Vue from "vue";
import Router from "vue-router";

// 通过重写VueRouter原型对象上的push方法, 覆盖原来抛出异常的方法, "吞掉"异常
// 开启吞并position
const originalPush = Router.prototype.push
// 覆盖原型链的push
Router.prototype.push = function push(location, resolve, reject) {
     // 判断用户有没有传后面两个可选参数
    if ( resolve || reject ) return originalPush.call(this, location, resolve, reject)
      /* 
      默认底层： catch()方法代码  throw err : 抛出异常
      吞掉报错原理： 重写catch()方法,把默认底层的 throw err给去掉，就不会抛出异常
      */
    return originalPush.call(this, location).catch(()=>{})
}

Vue.use(Router);
export const constantRoutes = [
    {
        path: "/index",
        name:'首页',
        component: () => import("@/views/index/index"),
        hidden: true,
        meta:{
            title:'首页',
        }
    },
    {
        path: "/list",
        name:'产品',
        component: () => import("@/views/list/index"),
        hidden: true,
        meta:{
            title:'产品',
        }
    },
    {
        path: "/detail",
        name:'品牌故事',
        component: () => import("@/views/detail/index"),
        hidden: true,
        meta:{
            title:'品牌故事',
        }
    },
    {
        path: "/about",
        name:'关于我们',
        component: () => import("@/views/about/index"),
        hidden: true,
        meta:{
            title:'关于我们',
        }
    },
    {
        path: "/position",
        name:'常见问题',
        component: () => import("@/views/position/index"),
        hidden: true,
        meta:{
            title:'常见问题',
        }
    },
    {
        path: "/callus",
        name:'联系我们',
        component: () => import("@/views/callus/index"),
        hidden: true,
        meta:{
            title:'联系我们',
        }
    },
    {
        path: "/404",
        name:'404',
        component: () => import("@/views/404"),
        hidden: true,
        meta:{
            title:'404',
        }
    },
    
]

const createRouter = () =>
  new Router({
    mode: "history",
    scrollBehavior: () => ({
      y: 0,
    }),
    routes: constantRoutes,
});
const router = createRouter();


export default router;